import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navItems = [
    { label: 'ホーム', href: '/' },
    { label: '理念', href: '/mission' },
    { label: 'サービス', href: '/services' },
    { label: 'お客様の声', href: '/testimonials' },
    { label: 'プロフィール', href: '/profile' },
    { label: '税理士の選び方', href: '/tax-accountant-guide' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-white shadow-sm'
            : 'bg-white'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" onClick={handleLinkClick} className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/638c1803-b247-452b-978a-cc144ee7337b.png" 
                alt="赤石会計事務所" 
                className="h-12 w-auto object-contain"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={handleLinkClick}
                  className={`text-[15px] font-medium text-gray-700 hover:text-red-600 transition-colors relative group whitespace-nowrap ${
                    location.pathname === item.href ? 'text-red-600' : ''
                  }`}
                >
                  {item.label}
                  <span
                    className={`absolute bottom-[-8px] left-0 w-full h-0.5 bg-red-600 transition-transform origin-left ${
                      location.pathname === item.href
                        ? 'scale-x-100'
                        : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                  ></span>
                </Link>
              ))}
            </nav>

            <div className="flex items-center gap-4">
              <a
                href="tel:075-351-0587"
                className="hidden md:flex items-center gap-2 text-sm text-gray-600 hover:text-red-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>075-351-0587</span>
              </a>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden lg:flex bg-red-600 text-white px-6 py-2.5 rounded-lg hover:bg-red-700 transition-colors text-[15px] font-medium whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </a>

              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
                aria-label="メニュー"
              >
                <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${
          isMobileMenuOpen ? 'visible' : 'invisible'
        }`}
      >
        <div
          className={`absolute inset-0 bg-black transition-opacity duration-300 ${
            isMobileMenuOpen ? 'opacity-50' : 'opacity-0'
          }`}
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>

        <div
          className={`absolute top-20 left-0 right-0 bg-white shadow-lg transition-transform duration-300 ${
            isMobileMenuOpen ? 'translate-y-0' : '-translate-y-full'
          }`}
        >
          <nav className="flex flex-col py-4">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={handleLinkClick}
                className={`px-8 py-4 text-[15px] font-medium text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors ${
                  location.pathname === item.href ? 'text-red-600 bg-red-50' : ''
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="px-8 py-4 border-t border-gray-100 mt-2">
              <a
                href="tel:075-351-0587"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-red-600 transition-colors mb-4 cursor-pointer"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>075-351-0587</span>
              </a>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors text-[15px] font-medium text-center whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </a>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
